class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.products = this.querySelector('.cart-upsell--products');
    this.navigation = this.querySelector('.cart-upsell--navigation');
    this.previousButton = this.querySelector('.cart-upsell--previous');
    this.nextButton = this.querySelector('.cart-upsell--next');

    if (!this.products) return;

    this.previousButton?.addEventListener('click', () => this.scrollByCard(-1));
    this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
    this.products.addEventListener('scroll', () => this.queueNavigationUpdate(), { passive: true });

    this.resizeObserver = new ResizeObserver(() => {
      this.updateNavigation();
      this.updateCartSummaryHeight();
    });
    this.resizeObserver.observe(this.products);
    this.resizeObserver.observe(this);

    this.mutationObserver = new MutationObserver(() => this.productsChanged());
    this.mutationObserver.observe(this.products, { childList: true });
    this.productsChanged();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    cancelAnimationFrame(this.navigationFrame);
    cancelAnimationFrame(this.summaryHeightFrame);
  }

  productsChanged() {
    const productCount = this.products.querySelectorAll('[data-product-item]').length;
    this.dataset.ready = productCount > 0 ? 'true' : 'false';
    this.navigation?.setAttribute('aria-hidden', productCount > 1 ? 'false' : 'true');
    if (productCount > 0) this.forceCartSummaryLayout();
    this.updateNavigation();
    this.updateCartSummaryHeight();
  }

  forceCartSummaryLayout() {
    const summary = this.closest('.cart--summary');
    if (!summary) return;

    summary.style.display = 'none';
    void summary.offsetHeight;
    summary.style.removeProperty('display');
    void summary.offsetHeight;
  }

  updateCartSummaryHeight() {
    cancelAnimationFrame(this.summaryHeightFrame);
    this.summaryHeightFrame = requestAnimationFrame(() => {
      const cart = this.closest('.cart--root[data-view="drawer"]');
      const summary = cart?.querySelector('.cart--summary');

      if (cart && summary) {
        cart.style.setProperty('--summary-height', `${summary.offsetHeight}px`);
      }
    });
  }

  scrollByCard(direction) {
    const card = this.products.querySelector('[data-product-item]');
    if (!card) return;

    const gap = parseFloat(getComputedStyle(this.products).columnGap) || 0;
    this.products.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  queueNavigationUpdate() {
    cancelAnimationFrame(this.navigationFrame);
    this.navigationFrame = requestAnimationFrame(() => this.updateNavigation());
  }

  updateNavigation() {
    const maximumScroll = Math.max(0, this.products.scrollWidth - this.products.clientWidth);
    const position = Math.abs(this.products.scrollLeft);
    const tolerance = 2;

    if (this.previousButton) this.previousButton.disabled = position <= tolerance;
    if (this.nextButton) this.nextButton.disabled = position >= maximumScroll - tolerance;
  }
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
